import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';
import { OrganisationDropdownComponentConfigurator } from './organisation-dropdown-component.configurator';
import { BaseComboboxDropdownComponent } from '@pl/pl-lib/forms';
import { Organisation } from 'src/app/core/models/organisation';

@Component({
  selector: 'app-organisation-searchable-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/combobox-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/combobox-dropdown.component.scss'
  ]
})
export class OrganisationSearchableDropdownComponent extends BaseComboboxDropdownComponent<Organisation> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new OrganisationDropdownComponentConfigurator();
  }
}
